import React from "react";
import { Carousel as PrimeCarousel } from "primereact/carousel";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import "./carousel.scss";

interface CarouselProps {
  items: Array<{ id: number; component: React.ComponentType }>;
}

export function Carousel({ items }: CarouselProps) {
  const itemTemplate = (item: { id: number; component: React.ComponentType }) => {
    const Template = item.component;
    return (
      <div className="carousel__item" key={item.id}>
        <Template />
      </div>
    );
  };

  const responsiveOptions = [
    {
      breakpoint: '2000px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '1600px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '1024px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  return (
    <div className="carousel">
      <PrimeCarousel
        value={items}
        itemTemplate={itemTemplate}
        numVisible={5}
        numScroll={5}
        responsiveOptions={responsiveOptions}
        circular
        className="custom-carousel"
      />
    </div>
  );
}
